import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{}} ArchiveNavProps
 */

/**
 * ArchiveNav ArchiveNav.
 * @augments {Base<ArchiveNavProps>}
 */
export default class ArchiveNav extends Base {
  timeout = null;

  static config = {
    name: 'ArchiveNav',
    refs: ['links[]', 'background'],
  };

  /**
   *
   */
  mounted() {
    this.activeLink = this.$el.querySelector('.is-active');
    this.moveIndicator(this.activeLink);
  }

  /**
   *
   * @param {*} param0
   */
  onLinksMouseenter({ target }) {
    clearTimeout(this.timeout);
    this.moveIndicator(target);
  }

  /**
   *
   */
  onLinksMouseleave() {
    this.timeout = setTimeout(() => {
      this.moveIndicator(this.activeLink);
    }, 300);
  }

  /**
   *
   * @param {object} element current element.
   * @returns {void}
   */
  moveIndicator(element) {
    if (!element) return;
    const { offsetLeft, offsetWidth } = element;
    this.$refs.background.style.width = `${offsetWidth}px`;
    this.$refs.background.style.transform = `translateX(${offsetLeft}px)`;
  }
}
